const PAGE_CHANGE = 'PageElementChange';

export default {
    PAGE_CHANGE,
};

export { PAGE_CHANGE };
